import { withTranslation } from 'react-i18next';
import withStableI18nProps from './withStableI18nProps';

/**
 * Combina withTranslation de react-i18next con nuestro HOC personalizado para optimizar
 * componentes que utilizan traducciones, evitando re-renderizados innecesarios.
 *
 * @param {string|Array<string>} ns - Namespace(s) para traducciones (opcional)
 * @returns {Function} - HOC para envolver componentes
 */
export const optimizeTranslatedComponent = (ns) => (Component) => {
  // Primero aplicamos withTranslation para proporcionar las props i18n
  const TranslatedComponent = withTranslation(ns)(Component);

  // Luego aplicamos nuestro HOC para estabilizar esas props y prevenir re-renders
  return withStableI18nProps(TranslatedComponent);
};

/**
 * Versión simplificada para usar con componentes existentes que ya están envueltos con withTranslation
 *
 * @param {React.Component} Component - Un componente ya envuelto con withTranslation
 * @returns {React.Component} - Componente optimizado
 */
export const optimizeExistingTranslated = (Component) => {
  return withStableI18nProps(Component);
};

export default optimizeTranslatedComponent;
